import { Box, Button, FormControl, FormLabel, IconButton, useMediaQuery, Zoom } from "@material-ui/core";
import { Add, Close } from "@material-ui/icons";
import React, { useCallback, useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useFormik } from "formik";
import { swalCondition } from "../../../../../utils/swalHelper";
import InputDatePicker from "../../../../components/InputDatePicker";
import SwitchIOS from "../../../../components/SwitchIOS";
import { serviceBannerSchema, useStyles } from "../helpers/formEditBannerServiceOption";
import { uniqueId } from "lodash";

function FormEditBannerService({ onSubmit = () => {}, initialFormValues = {}, onCancel = () => {} }) {
    const classStyle = useStyles();
    const bp_md_up = useMediaQuery(theme => theme.breakpoints.up("md"));

    // component state
    const [fileImages, setFileImages] = useState([]); // state list input file

    // config Form
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialFormValues,
        validationSchema: serviceBannerSchema,
        onSubmit: values => {
            onSubmit({ ...values, bannerImages: fileImages });
        },
    });

    // add file image
    const addFileImageMulti = (files = []) => {
        files.map(file => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async e => {
                const nameImg = file.name;
                setFileImages([{ id: uniqueId(), name: nameImg, src: e.target.result, file }]);
            };
            return reader;
        });
    };

    // delete file image
    const deleteFile = async id => {
        const isConfirm = await swalCondition('<div class="h3 t-text-primary">Are you delete?</div>', "", {
            icon: "error",
        });
        if (isConfirm) {
            setFileImages(currentState => currentState?.filter(prev => prev.id !== id));
        }
    };

    // set values date start to end formik and set state datepicker
    const handleChangeDate = useCallback(
        async (type, date) => {
            if (type === "start") {
                if (date > formik.values?.endDate) {
                    await formik.setFieldValue("bannerStartDate", date, true);
                    await formik.setFieldValue("bannerEndDate", date, true);
                } else {
                    await formik.setFieldValue("bannerStartDate", date, true);
                }
            } else if (type === "end") {
                if (date <= formik.values?.startDate) {
                    await formik.setFieldValue("bannerStartDate", date, true);
                    await formik.setFieldValue("bannerEndDate", date, true);
                } else {
                    await formik.setFieldValue("bannerEndDate", date, true);
                }
            }
        },
        [formik],
    );

    const handleChangeStatus = useCallback(
        async e => {
            await formik.setFieldValue("bannerStatus", e.target.checked, true);
        },
        [formik],
    );

    // set banner images to state
    useEffect(() => {
        if (formik.values?.bannerImages?.length) {
            setFileImages(formik.values?.bannerImages);
        }
    }, [formik.values.bannerImages]);

    return (
        <form onSubmit={formik.handleSubmit} id="fm_edit_banner_pack">
            <div className="col-12 mb-5 border-bottom pb-5">
                <p>Add Image <span className="text-danger">(720 x 300)</span> </p>
                <div className="row py-3" style={{ overflow: "auto", maxHeight: (bp_md_up ? 150 + 8 : 130 + 8) * 2 }}>
                    <div className={`col-6 col-lg-3 mb-2 ${fileImages.length > 0 ? "d-none" : ""}`}>
                        <Dropzone onDrop={acceptedFiles => addFileImageMulti(acceptedFiles)} maxFiles={1} multiple={false} accept={{ "image/*": [] }}>
                            {({ getRootProps, getInputProps, isDragActive }) => (
                                <section>
                                    <div
                                        {...getRootProps()}
                                        className={`${classStyle.boxClickuploadfile} ${isDragActive ? "isDrang" : ""}`}
                                        style={{ height: bp_md_up ? 150 : 130 }}>
                                        <input {...getInputProps()} />
                                        <Add style={{ fontSize: 32 }} />
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                    </div>
                    {fileImages.map((image, index) => (
                        <Zoom
                            key={"preview_" + image.id}
                            in={true}
                            style={{ transitionDelay: index + "00ms" }}
                            className="col-6 col-lg-3 mb-2">
                            <div>
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className={"position-relative w-100 " + classStyle.boxUpdateFile}>
                                        <div className={"position-absolute text-right w-100"}>
                                            <IconButton size="small" onClick={() => deleteFile(image.id)}>
                                                <Close className="text-danger" />
                                            </IconButton>
                                        </div>
                                        <Dropzone onDrop={acceptedFiles => addFileImageMulti(acceptedFiles)} maxFiles={1} multiple={false} accept={{ "image/*": [] }}>
                                            {({ getRootProps, getInputProps, isDragActive }) => (
                                                <section>
                                                    <div
                                                        {...getRootProps()}
                                                        className={`${classStyle.boxClickuploadfile} ${isDragActive ? "isDrang" : ""}`}>
                                                        <input {...getInputProps()} />
                                                        <img
                                                            src={image.src}
                                                            className={`${classStyle.imagePreview} ${bp_md_up ? "md" : ""}`}
                                                            alt={image.name}
                                                        />
                                                    </div>
                                                </section>
                                            )}
                                        </Dropzone>
                                    </div>
                                </div>
                            </div>
                        </Zoom>
                    ))}
                </div>
            </div>
            <div className="col-12 mb-5">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <Box className="w-100">
                            <FormLabel className="text-dark mb-4">Date Start</FormLabel>
                            <InputDatePicker
                                label=""
                                className="mt-0 t-form-group-custom"
                                onChange={date => handleChangeDate("start", date)}
                                value={formik.values?.bannerStartDate}
                                error={formik.touched?.bannerStartDate && Boolean(formik.errors?.bannerStartDate)}
                                helperText={formik.touched?.bannerStartDate && formik.errors?.bannerStartDate}
                            />
                        </Box>
                    </div>
                    <div className="col-12 col-md-4">
                        <Box className="w-100">
                            <FormLabel className="text-dark mb-4">Date End</FormLabel>
                            <InputDatePicker
                                label=""
                                className="mt-0 t-form-group-custom"
                                minDate={formik.values?.bannerStartDate}
                                onChange={date => handleChangeDate("end", date)}
                                value={formik.values?.bannerEndDate}
                                error={formik.touched?.bannerEndDate && Boolean(formik.errors?.bannerEndDate)}
                                helperText={formik.touched?.bannerEndDate && formik.errors?.bannerEndDate}
                            />
                        </Box>
                    </div>
                    <div className="col-12 col-md-4">
                        <FormControl className="t-form-group-custom">
                            <FormLabel className="text-dark mb-4">Status</FormLabel>
                            <SwitchIOS
                                color="default"
                                checked={formik.values?.bannerStatus}
                                onChange={handleChangeStatus}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-5">
                <div className="row justify-content-md-end">
                    <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                        <Button type="submit" className="w-100 btn t-btn-primary">
                            Save
                        </Button>
                    </div>
                    <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                        <Button type="button" className="w-100 btn t-btn-gray" onClick={onCancel}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default FormEditBannerService;
